"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Link_1 = __importDefault(require("@mui/material/Link"));
var StyledLink = (0, styles_1.styled)(Link_1.default)(function (_a) { return ({
    '&.MuiLink-button': {
        boxSizing: 'border-box',
        fontWeight: 500,
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '0.4rem',
        fontSize: '1.4rem',
        padding: '1.6rem 2.8rem',
        maxHeight: '4.8rem',
        border: '2px solid',
        boxShadow: 'none',
    },
}); });
exports.default = StyledLink;
